import { fetchTeamDetailsFail, fetchTeamDetailsSuccess } from './actions';
import { put, select } from 'redux-saga/effects';
import { makeErrorPayload } from '../../../../../../shared/helpers/payload.helper';
import { setErrorToast } from '../../../../../../shared/toast/redux/actions';
import { getTeamById } from '../team.backend';
import { getBrandsAndJurisdictions } from '../../../../../../jurisdiction/redux/selectors';
import { makeTeamDetailsWithBrandIds } from '../jurisdictions/sagas';

export function* fetchTeamDetailsSaga(action) {
    try {
        const response = yield getTeamById(action.payload);
        const { brands } = yield select(getBrandsAndJurisdictions);

        yield put(
            fetchTeamDetailsSuccess(
                makeTeamDetailsWithBrandIds(response.data, brands)
            )
        );
    } catch (error) {
        const formattedError = makeErrorPayload(error);

        yield put(fetchTeamDetailsFail(formattedError));
        yield put(setErrorToast(formattedError));
    }
}
